export default __webpack_public_path__ + "static/media/ai_image_3_origin.df11564f.jpg";